/* Teaching figures are enhancement-only; their adjacent text is always present.
   A custom element also upgrades figures inserted by a variant or editor swap. */
(() => {
  if (!('customElements' in window) || customElements.get('jp-illustration')) return;

  customElements.define('jp-illustration', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      const image = this.querySelector('img[data-svg-src]');
      if (!image) return;
      this.started = true;
      let state = 'svg';

      const onError = () => {
        this.classList.remove('is-ready');
        if (state === 'svg' && image.dataset.pngSrc) {
          state = 'png';
          image.srcset = image.dataset.pngSrcset || '';
          image.src = image.dataset.pngSrc;
        } else {
          state = 'failed';
          this.classList.add('is-failed');
          image.removeEventListener('error', onError);
          image.removeEventListener('load', onLoad);
        }
      };
      const onLoad = () => {
        if (!image.naturalWidth) return onError();
        this.classList.add('is-ready');
      };
      image.addEventListener('error', onError);
      image.addEventListener('load', onLoad);
      /* Listeners precede src, including cached or deferred responses.
         A cancelled request that emits no browser error stays safely invisible;
         no timeout guesses, polling or decode races trigger extra downloads. */
      image.src = image.dataset.svgSrc;
    }
  });
})();
